export default "__VITE_ASSET__2f9b37e0__"